import { PayoutType } from 'types';
import { useNavigate, handleMutation } from 'hooks';
import { useDeleteMutation } from 'store/api/payout';
import { DeleteDialog } from 'components/delete-dialog';
import { Messages, canDeleteReimbursementStatuses } from 'config';

import { RemovePayoutDialogProps } from './types';

const canDeleteType = [PayoutType.Reimbursements];

export const RemovePayoutDialog = ({
  data,
  withoutNavigate,
}: RemovePayoutDialogProps) => {
  const navigate = useNavigate();
  const [remove, removeMutation] = useDeleteMutation();

  handleMutation({
    ...removeMutation,
    successMessage: `Payout ${Messages.DELETED_SUCCESSFULLY}`,
  });

  const isDisplayDeletePayout =
    canDeleteReimbursementStatuses.includes(data?.status) &&
    canDeleteType.includes(data?.type);

  return (
    isDisplayDeletePayout && (
      <DeleteDialog
        id={data?.id}
        name="reimbursement"
        title="Delete Reimbursement"
        action={async (id) => {
          try {
            const response = await remove(id);
            if (!response.error && !withoutNavigate) {
              navigate(-1);
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    )
  );
};
